<app-nav titulo="Fianzas" descripcion="Aquí podrá ver, editar y borrar todas las fianzas.">
    <div class="guaranties">
        <app-table-filter [filters]="filters" (values)="setFilterValues($event)"></app-table-filter>
        <app-data-table
            [rows]="guaranties"
            [columns]="columns"
            [paginatorStatus]="paginatorStatus"
            [externalPagination]="true"
            (updateRows)="updateGuaranties($event)"
            (sortFn)="updateSort($event)"
        ></app-data-table>
    </div>
</app-nav>
<ng-template #buttonsColumnTemplate let-row="row">
    <div class="table-row-buttons">
        <button mat-raised-button class="garantor-button mini edit-row-button" color="primary" [routerLink]="'./' + row.id">
            {{ userType === 'CORPORATIVO' && row.estado !== 'ACTIVA' && row.estado !== 'BAJA_ANTICIPADA' && row.estado !== 'BAJA_POR_ADMIN' && row.estado !== 'BAJA_POR_AGENTE' ? 'Continuar' : 'Ver detalle' }}
        </button>
        <button mat-icon-button matTooltip="Dar de baja la garantía" class="delete-row-button" (click)="deleteWarranty(row)" *ngIf="userType === 'CORPORATIVO'">
            <mat-icon color="accent">delete</mat-icon>
        </button>
    </div>
</ng-template>
